const TAB_OPTION = {
  ADMINS: 'admins',
  USERS: 'users',
  MANAGER: 'manager',
  SUPPORT: 'support',
  COMPANIES: 'companies',
};

export default TAB_OPTION;
